import { t } from 'i18next';
import * as Yup from 'yup';

export const addempportalmenuType = Yup.object({
  name: Yup.string().required(t('required-field')),
});
